export const SET_WORDS_COUNT = '@recovery/recovery-set-words-count';
export const SET_ADVANCED_RECOVERY = '@recovery/recovery-set-advanced-recovery';
export const SET_ERROR = '@recovery/set-error';
export const RESET_REDUCER = '@recovery/reset-reducer';
export const SET_STATUS = '@recovery/set-status';
